"use strict";
var PromiseCompleter = (function () {
    function PromiseCompleter() {
        var _this = this;
        this.promise = new Promise(function (res, rej) {
            _this.resolve = res;
            _this.reject = rej;
        });
    }
    return PromiseCompleter;
}());
exports.PromiseCompleter = PromiseCompleter;
//# sourceMappingURL=/usr/local/google/home/jelbourn/material2/tmp/broccoli_type_script_compiler-input_base_path-IydvmmBU.tmp/0/core/async/promise-completer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular2-material/core/async/promise-completer.js
 ** module id = 375
 ** module chunks = 0 1
 **/